var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400.000000pt",
    height: "400.000000pt",
    viewBox: "0 0 400.000000 400.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,400.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2000 l0 -2000 2000 0 2000 0 0 2000 0 2000 -2000 0 -2000 0 0 -2000z m1956 885 c11 -15 14 -69 14 -265 0 -136 3 -249 6 -253 3 -3 41 12 84 34 111 57 207 75 321 60 155 -20 271 -79 368 -188 177 -198 214 -520 88 -758 -47 -88 -156 -194 -247 -238 -116 -57 -185 -72 -335 -72 -106 0 -145 5 -210 23 -158 46 -239 92 -548 315 -81 58 -186 125 -232 148 -77 38 -93 42 -158 42 -61 0 -82 -4 -124 -27 -47 -26 -123 -109 -123 -134 0 -24 -43 -33 -152 -30 l-113 3 -3 32 c-6 63 85 200 183 274 123 93 311 136 459 106 113 -23 182 -60 351 -187 325 -244 457 -313 642 -335 169 -19 354 78 420 221 34 75 42 194 19 284 -73 285 -390 385 -588 185 -74 -74 -100 -139 -107 -267 -7 -132 -14 -142 -78 -108 -25 13 -70 41 -99 62 l-54 39 -2 499 c-2 274 -1 509 2 521 8 31 34 39 123 36 65 -2 81 -6 93 -22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.47a6b3e494680b92306910f51749789b.svg";
export { ForwardRef as ReactComponent };